import type { LessonCreationStudiosVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveLessonCreationStudios = createApiThunk<LessonCreationStudiosVM, void>(
  "teacher/retrieve-lesson-creation-studios",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.getLessonCreationStudios();
  },
);
